import { BOARD_SIZE } from '../config/board.ts'
import { AI_EVAL } from '../config/ai.ts'
import { placeStone, scoreGainIfPlace } from './engine.ts'
import { scanThroughPoint } from './threat-scan.ts'
import type { Cell } from './types.ts'

// 指定マスに置いた場合の評価スコアを計算する（1 手先読み）
// ai.ts と ai-engines/* の双方から参照されるため、循環依存回避のため独立ファイルに配置。
//
// 2026-04-17: 連続石ベース (analyzeDirection) から「5連窓」ベースに変更。
// 飛び4 (BBB_B など) も 4石窓として検出され、HELL が見逃していたギャップ脅威を
// 同じ土台で評価できるようになった（AI_EVAL コメント参照）。
export function evalPosition(
  board: Cell[][],
  row: number,
  col: number,
  color: 'black' | 'white',
  opp: 'black' | 'white'
): number {
  if (board[row][col] !== 'empty') return -Infinity

  const testBoard = placeStone(board, row, col, color)
  const testBoardOpp = placeStone(board, row, col, opp)

  // 自分がここに置いた場合、(row,col) を通る 5連窓の分類
  const mine = scanThroughPoint(testBoard, row, col, color)
  // 相手がここに置いた場合、(row,col) を通る 5連窓の分類（放置時の相手脅威）
  const theirs = scanThroughPoint(testBoardOpp, row, col, opp)

  let score = 0

  if (mine.five >= 1) {
    score += AI_EVAL.WIN
  } else {
    score += mine.four * AI_EVAL.FOUR
    score += mine.three * AI_EVAL.THREE
    score += mine.two * AI_EVAL.TWO
  }

  if (theirs.five >= 1) {
    score += AI_EVAL.BLOCK_WIN
  } else {
    score += theirs.four * AI_EVAL.BLOCK_FOUR
    score += theirs.three * AI_EVAL.BLOCK_THREE
    score += theirs.two * AI_EVAL.BLOCK_TWO
  }

  // 中心引力
  const center = Math.floor(BOARD_SIZE / 2)
  const dist = Math.abs(row - center) + Math.abs(col - center)
  score += Math.max(0, BOARD_SIZE - dist) * AI_EVAL.CENTER_BIAS

  // スコアゲイン加算（スコア連鎖五目のCPUはナワバリ得点も意識する）
  const gain = scoreGainIfPlace(board, row, col, color)
  score += gain * AI_EVAL.SCORE_GAIN_WEIGHT

  return score
}
